import React from 'react'
import { bool, object } from 'prop-types'
import { Box, makeStyles, Typography } from '@material-ui/core'
import CheckOutlined from '@mui/icons-material/CheckOutlined'
import CloseOutlined from '@mui/icons-material/CloseOutlined'

const useStyles = makeStyles(theme => ({
  list: {
    fontSize: '14px',
    '& > p': {
      display: 'flex',
      flexDirection: 'row',
      '& > svg': {
        width: '16px',
        marginRight: '5px',
      },
      '& > p': {
        fontSize: '14px',
      },
    },
  },
  successRequirement: {
    '&, & > p': {
      color: theme.palette.success.main,
      fontWeight: '500',
    },
  },
  failedRequirement: {
    '&, & > p': {
      color: theme.palette.error.main,
      fontWeight: '500',
    },
  },
  defaultRequirement: {
    '&, & > p': {
      color: theme.palette.secondary.dark,
      fontWeight: '500',
    },
  },
}))

const requirements = [
  { text: 'Must be at least 8 characters long', id: 'req-1' },
  { text: 'Must have at least one uppercase letter', id: 'req-2' },
  { text: 'Must have at least one lowercase letter', id: 'req-3' },
  { text: 'Must have at least one number', id: 'req-4' },
  // { text: 'One special character ~!@#$%^&*()_+.,/;:<=>?', id: 'req-5' },
]

const PasswordRequirements = ({ errors, isTouched }) => {
  const classes = useStyles()

  return (
    <Box>
      <Box className={classes.list}>
        {requirements.map(({ id, text }) => {
          const isFailedRequirement = isTouched && !!errors?.password?.includes?.(`Password ${text?.toLowerCase()}`)

          return (
            <Typography
              key={id}
              variant="body1"
              className={
                (isFailedRequirement !== undefined &&
                  (isFailedRequirement ? classes.failedRequirement : classes.successRequirement)) ||
                null
              }
            >
              {isFailedRequirement !== undefined && (isFailedRequirement ? <CloseOutlined /> : <CheckOutlined />)}
              <Typography>{text}</Typography>
            </Typography>
          )
        })}
      </Box>
    </Box>
  )
}

PasswordRequirements.propTypes = {
  errors: object,
  isTouched: bool,
}

export default PasswordRequirements
